<template>
  <div class="wrp">
    <h1 class="h1 clear">
      Insights
      <div v-if="isPro" class="mode-wrap clear">
        <div class="switch" :class="{'active': currentMode === 1}" @click="switchMode"></div>
        <div class="text">What If Mode</div>
      </div>
    </h1>
    <div v-if="isPro" class="table-wrp venue">
      <!-- 如果是没开启的状态就显示这个table -->
      <div v-if="currentMode === 0" class="ros">
        <el-table
            :data="showTableData"
            border
            :show-header="false"
            style="width: 100%">
          <el-table-column>
            <template slot-scope="scope">
              <div v-if="scope.row.sort !== 4 && scope.row.sort !== 1" class="normal">

                 <template v-if="scope.row.sort == 0">
                    {{scope.row.tit}} <el-tag size="small">{{isGstAdded ? 'Inc-GST' : 'Ex-GST' }}</el-tag>
                  </template>
                  <template v-else>
                    {{scope.row.tit}}
                  </template>
              </div>
              <div v-else-if="scope.row.sort == 4" class="bold-row clear-float">{{scope.row.tit}}<i class="switch" @click="toggle"></i></div>
              <div v-else-if="scope.row.sort === 1" class="bold-row clear-float">{{scope.row.tit}}<i class="visible"
              :class="{'invisible': !pinVisible}" @click="pinValidate"></i></div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <!-- <div v-if="true" class="normal rgt">{{scope.row.num1 === null ? '-' : scope.row.num1}}</div>
              <div v-else-if="scope.row.sort === 1" class="normal rgt">{{pinVisible ? (scope.row.num1 === null ? '-' : scope.row.num1) : '**'}}</div> -->
              <div class="bold-row rgt">{{scope.row.num1}}</div>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <!-- <div v-if="scope.row.sort !== 4 && scope.row.sort !== 1" class="normal rgt">{{scope.row.num2}}</div>
              <div v-else-if="scope.row.sort === 1" class="normal rgt">{{pinVisible ? scope.row.num2 : '**'}}</div> -->
              <div class="bold-row rgt">{{scope.row.num2}}</div>
            </template>
          </el-table-column>
          <template slot="empty">
            <i v-if="loading" class="el-icon-loading" style="font-size:20px"></i>
            <div v-else>-</div>
          </template>
        </el-table>
      </div>
      <!-- 如果是开启的状态就显示这个锁头列表 -->
      <div class="edit-table" v-if="currentMode === 1">

        <div class="line clear">
          <div class="cloumn">Weekly Revenue</div>
          <div class="cloumn"></div>
          <div class="cloumn">
            <input ref="revenue" @change="updateInfo('revenue')" v-show="!showRevenueFormat" class="input2" maxlength="10"
            @blur="showRentFormat = true"
            v-model="revenue" @input="revenue=revenue.match(/\d+\.?\d{0,2}/)" />
            <div @click="focus('revenue')" v-show="showRevenueFormat" class="format-value">{{$box.formatMoney2(revenue)}}</div>
          </div>
        </div>

        <div class="line clear" :class="{'locked': profitLock === 1 || profitLock === 2}">
          <div class="cloumn">Profit target</div>
          <div class="cloumn">
            <div class="unlock" v-show="profitLock === 0 || profitLock === 2" @click="profitLock = 1"></div>
            <div class="lock" v-show="profitLock === 1" @click="profitLock = 0"></div>
            <input :disabled="profitLock !== 0" class="input1" @change="updateInfo('profit1')" maxlength="5" v-model="profit1" @input="profit1=profit1.match(/\d+\.?\d{0,2}/)" />
            <div class="perc">%</div>
          </div>
          <div class="cloumn">
            <div class="unlock" v-show="profitLock === 0 || profitLock === 1" @click="profitLock = 2"></div>
            <div class="lock" v-show="profitLock === 2" @click="profitLock = 0"></div>
            <input @blur="showProfitFormat = true" :disabled="profitLock !== 0" ref="profit" @change="updateInfo('profit2')" v-show="!showProfitFormat" class="input2" maxlength="10" v-model="profit2" @input="profit2=profit2.match(/\d+\.?\d{0,2}/)" />
            <div @click="focus('profit')" v-show="showProfitFormat" class="format-value">{{$box.formatMoney2(profit2)}}</div>
          </div>
        </div>

        <div v-if="isPro" class="line clear" :class="{'locked': profitLock !== 0 && oeLock !== 0 && labourLock !== 0}">
          <div class="cloumn">COGs</div>
          <div class="cloumn">
            <input :disabled="profitLock !== 0 && oeLock !== 0 && labourLock !== 0" class="input1" @change="updateInfo('cog1')" maxlength="5" v-model="cog1" @input="cog1=cog1.match(/\d+\.?\d{0,2}/)" />
            <div class="perc">%</div>
          </div>
          <div class="cloumn">
            <input @blur="showCogFormat = true" ref="cog" @change="updateInfo('cog2')" v-show="!showCogFormat" class="input2" maxlength="10" v-model="cog2" @input="cog2=cog2.match(/\d+\.?\d{0,2}/)" />
            <div @click="focus('cog')" v-if="showCogFormat" class="format-value">{{$box.formatMoney2(cog2)}}</div>
          </div>
        </div>

        <div v-if="isPro" class="line clear" :class="{'locked': oeLock === 1 || oeLock === 2}">
          <div class="cloumn">Operating Expenses</div>
          <div class="cloumn">
            <div class="unlock" v-if="oeLock === 0 || oeLock === 2" @click="oeLock = 1"></div>
            <div class="lock" v-if="oeLock === 1" @click="oeLock = 0"></div>
            <input :disabled="oeLock !== 0" class="input1" @change="updateInfo('oe1')" maxlength="5" v-model="oe1" @input="oe1=oe1.match(/\d+\.?\d{0,2}/)" />
            <div class="perc">%</div>
          </div>
          <div class="cloumn">
            <div class="unlock" v-if="oeLock === 0 || oeLock === 1" @click="oeLock = 2"></div>
            <div class="lock" v-show="oeLock === 2" @click="oeLock = 0"></div>
            <input @blur="showOeFormat = true" :disabled="oeLock !== 0" ref="oe" @change="updateInfo('oe2')" v-show="!showOeFormat" class="input2" maxlength="10" v-model="oe2" @input="oe2=oe2.match(/\d+\.?\d{0,2}/)" />
            <div @click="focus('oe')" v-if="showOeFormat" class="format-value">{{$box.formatMoney2(oe2)}}</div>
          </div>
        </div>

        <div v-if="isPro" class="line clear">
          <div class="cloumn">Weekly Rent</div>
          <div class="cloumn">
            <input class="input1" @change="updateInfo('rent1')" maxlength="5" v-model="rent1"
            @input="rent1=rent1.match(/\d+\.?\d{0,2}/)" />
            <div class="perc">%</div>
          </div>
          <div class="cloumn">
            <input @blur="showRentFormat = true" ref="rent" @change="updateInfo('rent2')" v-show="!showRentFormat" class="input2"
            maxlength="10" v-model="rent2" @input="rent2=rent2.match(/\d+\.?\d{0,2}/)" />
            <div @click="focus('rent')" v-if="showRentFormat" class="format-value">{{$box.formatMoney2(rent2)}}</div>
          </div>
        </div>

        <div class="line clear" :class="{'locked': labourLock === 1 || labourLock === 2}">
          <div class="cloumn">Labour($)</div>
          <div class="cloumn">
            <div class="unlock" v-if="labourLock === 0 || labourLock === 2" @click="labourLock = 1"></div>
            <div class="lock" v-if="labourLock === 1" @click="labourLock = 0"></div>
            <input :disabled="labourLock !== 0" class="input1" @change="updateInfo('labour1')" maxlength="5" v-model="labour1" @input="labour1=labour1.match(/\d+\.?\d{0,2}/)" />
            <div class="perc">%</div>
          </div>
          <div class="cloumn">
            <div class="unlock" v-if="labourLock === 0 || labourLock === 1" @click="labourLock = 2"></div>
            <div class="lock" v-show="labourLock === 2" @click="labourLock = 0"></div>
            <input @blur="showLabourFormat = true" :disabled="labourLock !== 0" ref="labour" @change="updateInfo('labour2')" v-show="!showLabourFormat" class="input2" maxlength="10" v-model="labour2" @input="labour2=labour2.match(/\d+\.?\d{0,2}/)" />
            <div @click="focus('labour')" v-if="showLabourFormat" class="format-value">{{$box.formatMoney2(labour2)}}</div>
          </div>
        </div>

      </div>
    </div>

    <template v-if="isDoneLoad && !isPro">
        <div class="error-container d-flex align-items-center justify-content-center">
            <card-unauthorized></card-unauthorized>
        </div>
    </template>

    <pin-dialog :visible="visible" @receive="receiveEvents" />

    <pin-mode-dialog :visible="modeVisible" @receive="receiveModeEvents" />

    <el-dialog :visible.sync="isTrialEnd" class="peiso-modal" width="810px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <free-trial-notice :info="venueDiscountDetailsPojo" :isPro="isPro" @close-notice="closeOrLogoutVenue"></free-trial-notice>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/venue'
import Api from '../../api/dashboard'
// import md5 from 'js-md5'
import pinDialog from '../common/pin'
import pinModeDialog from '../common/pin'
import cardUnauthorized from '@/components/card/unauthorized';
import freeTrialNotice from '@/components/modal/freeTrialNotice';

export default {
  name: 'headcon',
  data () {
    return {
      venueType: sessionStorage.getItem('venueType'),
      isPinNeeded: sessionStorage.getItem('isPinNeeded'),
      pinStatus: sessionStorage.getItem('pinstatus'),

      loading: true,
      tableData: [],
      temp: '-',

      pincodes: null,
      visible: false, // 2021/12/30
      pinVisible: false,

      currentMode: 0,
      modeVisible: false,
      /************************* 计算器 **************************/

      revenue: null,
      showRevenueFormat: true,

      profit1: null,
      profit2: null,
      profitLock: 0, // 0 是都解锁，1是锁第1个值，2是锁第2个值
      showProfitFormat: true, // 是否显示格式化后的值，默认true

      cog1: null,
      cog2: null,
      showCogFormat: true, // 是否显示格式化后的值，默认true

      oe1: null,
      oe2: null,
      oeLock: 0, // 0 是都解锁，1是锁第1个值，2是锁第2个值
      showOeFormat: true, // 是否显示格式化后的值，默认true

      rent1: null,
      rent2: null,
      showRentFormat: true,

      labour1: null,
      labour2: null,
      labourLock: 0, // 0 是都解锁，1是锁第1个值，2是锁第2个值
      showLabourFormat: true, // 是否显示格式化后的值，默认true

      timeout: [],
      isPro: false,
      isDoneLoad: false,

      venueDiscountDetailsPojo: null,
      isTrialEnd: false,
      isGstAdded: false
    }
  },
  mounted() {

    Api.progress({ callback: (res) => {
      if (res.data.code == 0) {
          this.isGstAdded = res.data.data.isGstAdded ? true : false
      }
    }});


    this.$root.$on('isPro', (isPro, others) => {
      this.isPro = isPro
      this.isDoneLoad = true
      this.venueTargets()



      const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
      if (others.venueDiscountDetailsPojo && others.venueDiscountDetailsPojo.remainingDays <= 3 && isContUsingTrial == '0') {
        this.venueDiscountDetailsPojo = others.venueDiscountDetailsPojo
        this.isTrialEnd =  true
      }
    })
  },
  methods: {
    focus (type) {
      if (type === 'profit') {
        if (this.profitLock !== 0)
          return
        this.showProfitFormat = false
        let timeout = setTimeout(() => {
          this.$refs.profit.focus()
        }, 200)
        this.timeout.push(timeout)
      } else if (type === 'labour') {
        if (this.labourLock !== 0)
          return
        this.showLabourFormat = false
        let timeout = setTimeout(() => {
          this.$refs.labour.focus()
        }, 200)
        this.timeout.push(timeout)
      } else if (type === 'oe') {
        if (this.oeLock !== 0)
          return
        this.showOeFormat = false
        let timeout = setTimeout(() => {
          this.$refs.oe.focus()
        }, 200)
        this.timeout.push(timeout)
      } else if (type === 'cog') {
        if (this.profitLock !== 0 && this.labourLock !== 0 && this.oeLock !== 0)
          return
        this.showCogFormat = false
        let timeout = setTimeout(() => {
          this.$refs.cog.focus()
        }, 200)
        this.timeout.push(timeout)
      } else if (type === 'revenue') {
        this.showRevenueFormat = false
        let timeout = setTimeout(() => {
          this.$refs.revenue.focus()
        }, 200)
        this.timeout.push(timeout)
      } else if (type === 'rent') {
        this.showRentFormat = false
        let timeout = setTimeout(() => {
          this.$refs.rent.focus()
        }, 200)
        this.timeout.push(timeout)
      }
    },
    switchMode () {
      if (this.currentMode === 0) {
        if (this.venueType === '1') {
          this.currentMode = 1
        } else {
          if (this.profit1 === null || this.profit2 === null ||
          this.cog1 === null || this.cog2 === null ||
          this.oe1 === null || this.oe2 === null ||
          this.labour1 === null || this.labour2 === null) {
            Utils.alert('', 'Please enter all data before you can start the simulation mode' ,'error')
            return
          }
          this.modeVisible = true
        }
      }
      else {
        api.venueTargets({
          callback: this.callback
        })
        this.currentMode = 0
      }
    },
    updateInfo (type) {
      if (type === 'profit1') {
        this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
        // 情况1 , 改profit target的百分比，labour没有锁定
        if (this.labourLock === 0) {
          this.labour1 = (100 - Number(this.profit1) - Number(this.cog1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = (Number(this.revenue) * Number(this.labour1) / 100).toFixed(2)
        // 情况2 , 改profit target的百分比，labour 锁定了
        } else if (this.labourLock !== 0) {
          this.cog1 = (100 - Number(this.profit1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.cog2 = (Number(this.revenue) * Number(this.cog1) / 100).toFixed(2)
        }
      } else if (type === 'profit2') {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.showProfitFormat = true

        // 情况3 , 改profit target的金额，labour没有锁定
        if (this.labourLock === 0) {
          this.labour2 = (Number(this.revenue) - Number(this.profit2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // 情况4 , 改profit target的金额，labour 锁定了
        } else if (this.labourLock !== 0) {
          this.cog2 = (Number(this.revenue) - Number(this.profit2) - Number(this.labour2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.cog1 = (Number(this.cog2) / Number(this.revenue) * 100).toFixed(2)
        }

      } else if (type === 'cog1') {
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)

        // 情况5 , 改COGs的百分比，labour没有锁定
        if (this.labourLock === 0) {
          this.labour1 = (100 - Number(this.profit1) - Number(this.cog1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = (Number(this.revenue) * Number(this.labour1) / 100).toFixed(2)
        // 情况6 , 改COGs的百分比，labour 锁定了，Profit target没有锁定
        } else if (this.profitLock === 0 && this.labourLock !== 0) {
          this.profit1 = (100 - Number(this.cog1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
        // 情况7 , 改COGs的百分比，labour / Profit target锁定了
        } else if (this.profitLock !== 0 && this.labourLock !== 0) {
          this.oe1 = (100 - Number(this.profit1) - Number(this.labour1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
          this.oe2 = (Number(this.revenue) * Number(this.oe1) / 100).toFixed(2)
        }

      } else if (type === 'cog2') {
        this.cog1 = (Number(this.cog2) / Number(this.revenue) * 100).toFixed(2)
        this.showCogFormat = true

        // 情况10 , 改COGs的金额，labour没有锁定
        if (this.labourLock === 0) {
          this.labour2 = (Number(this.revenue) - Number(this.profit2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // 情况11 , 改COGs的金额，labour 锁定了，Profit target没有锁定
        } else if (this.profitLock === 0 && this.labourLock !== 0) {
          this.profit2 = (Number(this.revenue) - Number(this.labour2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        // 情况12 , 改COGs的金额，labour / Profit target锁定了
        } else if (this.profitLock !== 0 && this.oeLock === 0 && this.labourLock !== 0) {
          this.oe2 = (Number(this.revenue) - Number(this.labour2) - Number(this.cog2) - Number(this.profit2) - Number(this.rent2)).toFixed(2)
          this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        }


      } else if (type === 'oe1') {
        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)

        // 情况13 , 改Operating Expenses的百分比，labour没有锁定
        if (this.labourLock === 0) {
          this.labour1 = (100 - Number(this.profit1) - Number(this.cog1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = (Number(this.revenue) * Number(this.labour1) / 100).toFixed(2)
        // 情况14 , 改Operating Expenses的百分比，labour 锁定了,Profit target没有锁定
        } else if (this.profitLock === 0 && this.labourLock !== 0) {
          this.profit1 = (100 - Number(this.cog1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
        // 情况15 , 改Operating Expenses的百分比，labour / Profit target锁定了
        } else if (this.profitLock !== 0 && this.labourLock !== 0) {
          this.cog1 = (100 - Number(this.profit1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.cog2 = (Number(this.revenue) * Number(this.cog1) / 100).toFixed(2)
        }


      } else if (type === 'oe2') {
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        this.showOeFormat = true

        // 情况16 , 改COGs的百分比，labour没有锁定
        if (this.labourLock === 0) {
          this.labour2 = (Number(this.revenue) - Number(this.profit2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // 情况17 , 改COGs的百分比，labour 锁定了，Profit target没有锁定
        } else if (this.profitLock === 0 && this.labourLock !== 0) {
          this.profit2 = (Number(this.revenue) - Number(this.labour2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        // 情况18 , 改COGs的百分比，labour / Profit target锁定了
        } else if (this.profitLock !== 0 && this.labourLock !== 0) {
          this.cog2 = (Number(this.revenue) - Number(this.profit2) - Number(this.labour2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.cog1 = (Number(this.cog2) / Number(this.revenue) * 100).toFixed(2)
        }

      } else if (type === 'labour1') {
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

        // 情况19 , 改Labour的百分比，Profit target没有锁定
        if (this.profitLock === 0) {
          this.profit1 = (100 - Number(this.cog1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
        // 情况20 , 改Labour的百分比，Profit target锁定了
        } else if (this.profitLock !== 0) {
          this.cog1 = (100 - Number(this.profit1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.cog2 = (Number(this.revenue) * Number(this.cog1) / 100).toFixed(2)
        }

      } else if (type === 'labour2') {
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        this.showLabourFormat = true

        // 情况21 , 改Labour的金额，Profit target没有锁定
        if (this.profitLock === 0) {
          this.profit2 = (Number(this.revenue) - Number(this.labour2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        // 情况22 , 改Labour的金额，Profit target锁定了
        } else if (this.profitLock !== 0) {
          this.cog2 = (Number(this.revenue) - Number(this.labour2) - Number(this.oe2) - Number(this.profit2) - Number(this.rent2)).toFixed(2)
          this.cog1 = (Number(this.cog2) / Number(this.revenue) * 100).toFixed(2)
        }

      } else if (type === 'rent1') {
        this.rent2 = ((Number(this.revenue) * Number(this.rent1) / 100)).toFixed(2)
        // 情况23 , 改rent的百分比，Labour没有锁定
        if (this.labourLock === 0) {
          this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
        // 情况24 , 改rent的百分比，Labour锁定了
        } else if (this.profitLock === 0) {
          this.profit1 = (100 - Number(this.cog1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        } else {
          this.cog1 = (100 - Number(this.profit1) - Number(this.labour1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.cog2 = (Number(this.revenue) * Number(this.cog1) / 100).toFixed(2)
        }

      } else if (type === 'rent2') {
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        this.showRentFormat = true

        // 情况25 , 改rent的金额，Labour没有锁定
        if (this.labourLock === 0) {
          this.labour2 = (Number(this.revenue) - Number(this.profit2) - Number(this.cog2) - Number(this.oe2) - Number(this.rent2)).toFixed(2)
          this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // 情况26 , 改rent的金额，Labour锁定了
        } else if (this.profitLock === 0) {
          this.profit2 = (Number(this.revenue) - Number(this.labour2) - Number(this.oe2) - Number(this.cog2) - Number(this.rent2)).toFixed(2)
          this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        } else {
          this.cog2 = (Number(this.revenue) - Number(this.labour2) - Number(this.oe2) - Number(this.profit2) - Number(this.rent2)).toFixed(2)
          this.cog1 = (Number(this.cog2) / Number(this.revenue) * 100).toFixed(2)
        }
    } else if (type === 'revenue') {
        this.showRevenueFormat = true
        if (!this.revenue) {
          this.revenue = '0'
        }
        // 情况1，全部没锁
        if (this.profitLock === 0 && this.oeLock === 0 && this.labourLock === 0) {
          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
          // 分担给labour去变化
          this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
          this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          return
        }
      // 假设 profit1 是 A ， profit2 是 B ，oe1 是 C ， oe2 是 D，labour1 是 E ， labour2 是 F

      // 分别有三大类情况，只有一个锁头，有两个锁头，有三个锁头

      // 只有一个锁头的情况(只考虑锁百分比)start *******************************************
      // 只锁住了A
        if (this.profitLock === 1 && this.oeLock === 0 && this.labourLock === 0) {
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
          // 差额由labour承担
          this.labour1 = (100 - Number(this.profit1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
          this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          return
        }
      // 只锁住了C
        if (this.oeLock === 1 && this.profitLock === 0 && this.labourLock === 0) {
          this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
          // 差额由labour承担
          this.labour1 = (100 - Number(this.profit1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          return
        }
      // 只锁住了E
        if (this.labourLock === 1 && this.oeLock === 0 && this.profitLock === 0) {
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
          // 差额由profit承担
          this.profit1 = (100 - Number(this.labour1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
          this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          return
        }

      // 只有一个锁头的情况(只考虑锁百分比)start *******************************************

      // 只有一个锁头的情况(只考虑锁金额)start *******************************************

        // 只锁住了B
        if (this.profitLock === 2 && this.oeLock === 0 && this.labourLock === 0) {
          this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
          // 分担给labour去变化
          this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

          this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          return
        }
        // 只锁住了D
        if (this.profitLock === 0 && this.oeLock === 2 && this.labourLock === 0) {
          this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)

          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
          // 分担给labour去变化
          this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
          this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          return
        }

        // 只锁住了F
        if (this.profitLock === 0 && this.oeLock === 0 && this.labourLock === 2) {
          this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
          // rent 金额是固定不变的，需要改变rent的百分比
          this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

          // 差额由profit承担
          this.profit1 = (100 - Number(this.labour1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
          this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)
          this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
          this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
          return
        }

      // 只有一个锁头的情况(只考虑锁金额)end *******************************************

      // 只有2个锁头的情况 start AC / AD / AE / AF / BC / BD /BE /BF / CE / CF / DE / DF
      // AC
      if (this.profitLock === 1 && this.oeLock === 1 && this.labourLock === 0) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.oe2 = (Number(this.revenue) * Number(this.oe1) / 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给labour去变化
        this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // AE
      if (this.profitLock === 1 && this.oeLock === 0 && this.labourLock === 1) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.labour2 = (Number(this.revenue) * Number(this.labour1) / 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)

        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        return
      }
      // BC
      if (this.profitLock === 2 && this.oeLock === 1 && this.labourLock === 0) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.oe2 = (Number(this.revenue) * Number(this.oe1) / 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给labour去变化
        this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // CE
      if (this.profitLock === 0 && this.oeLock === 1 && this.labourLock === 1) {
        this.oe2 = (Number(this.revenue) * Number(this.oe1) / 100).toFixed(2)
        this.labour2 = (Number(this.revenue) * Number(this.labour1) / 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 差额由profit承担
        this.profit1 = (100 - Number(this.labour1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
        this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // AD
      if (this.profitLock === 1 && this.oeLock === 2 && this.labourLock === 0) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给labour去变化
        this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // AF
      if (this.profitLock === 1 && this.oeLock === 0 && this.labourLock === 2) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)

        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        return
      }
      // BD
      if (this.profitLock === 2 && this.oeLock === 2 && this.labourLock === 0) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给labour去变化
        this.labour1 = (100 - Number(this.cog1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }

      // BE
      if (this.profitLock === 2 && this.oeLock === 0 && this.labourLock === 1) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)

        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
      }
      // CF
      if (this.profitLock === 0 && this.oeLock === 1 && this.labourLock === 2) {
        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 差额由profit承担
        this.profit1 = (100 - Number(this.labour1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
        this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // DE
      if (this.profitLock === 0 && this.oeLock === 2 && this.labourLock === 1) {
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 差额由profit承担
        this.profit1 = (100 - Number(this.labour1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
        this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // DF
      if (this.profitLock === 0 && this.oeLock === 2 && this.labourLock === 2) {
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 差额由profit承担
        this.profit1 = (100 - Number(this.labour1) - Number(this.oe1) - Number(this.cog1) - Number(this.rent1)).toFixed(2)
        this.profit2 = ((Number(this.revenue) * Number(this.profit1) / 100)).toFixed(2)

        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // BF
      if (this.profitLock === 2 && this.oeLock === 0 && this.labourLock === 2) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)
        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)

        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
      }

      // 只有2个锁头的情况 end *******************************************

      // 只有3个锁头的情况 start ACE / ACF / ADE / ADF / BCE / BCF / BDE / BDF
      // ACE
      if (this.profitLock === 1 && this.oeLock === 1 && this.labourLock === 1) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }

      // ACF
      if (this.profitLock === 1 && this.oeLock === 1 && this.labourLock === 2) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // ADF
      if (this.profitLock === 1 && this.oeLock === 2 && this.labourLock === 2) {
        this.profit2 = (Number(this.revenue) * Number(this.profit1) / 100).toFixed(2)
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // BCE
      if (this.profitLock === 2 && this.oeLock === 1 && this.labourLock === 1) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // BCF
      if (this.profitLock === 2 && this.oeLock === 1 && this.labourLock === 2) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.oe2 = ((Number(this.revenue) * Number(this.oe1) / 100)).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // BDE
      if (this.profitLock === 2 && this.oeLock === 1 && this.labourLock === 1) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        this.labour2 = ((Number(this.revenue) * Number(this.labour1) / 100)).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
        return
      }
      // BDF
      if (this.profitLock === 2 && this.oeLock === 2 && this.labourLock === 2) {
        this.profit1 = (Number(this.profit2) / Number(this.revenue) * 100).toFixed(2)
        this.oe1 = (Number(this.oe2) / Number(this.revenue) * 100).toFixed(2)
        this.labour1 = (Number(this.labour2) / Number(this.revenue) * 100).toFixed(2)
        // rent 金额是固定不变的，需要改变rent的百分比
        this.rent1 = (Number(this.rent2) / Number(this.revenue) * 100).toFixed(2)

        // 分担给cogs去变化
        this.cog1 = (100 - Number(this.labour1) - Number(this.profit1) - Number(this.oe1) - Number(this.rent1)).toFixed(2)
        this.cog2 = ((Number(this.revenue) * Number(this.cog1) / 100)).toFixed(2)
      }
      // 只有3个锁头的情况 end *******************************************
    }

    },
    receiveEvents (type) {
      this.visible = false
      if (type === 'confirm') {
        this.pinVisible = true
      }
    },
    receiveModeEvents (type) {
      this.modeVisible = false
      if (type === 'confirm') {
        this.currentMode = 1
      }
    },
    pinValidate () {
      if (this.pinStatus == 'true' && this.isPinNeeded == '1') {
        this.visible = true
      } else {
        this.pinVisible = !this.pinVisible
      }

    },
    venueTargets() {
      this.addTableData()
      api.venueTargets({
        callback: this.callback
      })
    },
    // 2021/12/30
    callback (res) {
      /*res.data.data = {
        averageHourlyRate: 20,
        cogs: 20,
        cogsPercentage: 20,
        forecastRevenue: 100,
        labourCost: 20,
        labourCostPercentage: 20,
        labourHours: 20,
        operatingExpenses: 20,
        operatingExpensesPercentage: 20,
        profitTarget: 20,
        profitTargetPercentage: 20,
        weeklyRent: 20,
        weeklyRentPercentage: 20
      }*/
      if (res.data.code == 0) {
        res.data.data.weeklyRentPercentage = res.data.data.weeklyRentPercentage === null ? 0 : res.data.data.weeklyRentPercentage
        res.data.data.weeklyRent = res.data.data.weeklyRent === null ? 0 : res.data.data.weeklyRent
        // 第一行
        if (res.data.data.forecastRevenue)
          this.tableData[0].num2 = '$' + Utils.formatSplit(res.data.data.forecastRevenue)
        // 第二行
        if (res.data.data.profitTargetPercentage)
          this.tableData[1].num1 = res.data.data.profitTargetPercentage + '%'
        if (res.data.data.profitTarget)
          this.tableData[1].num2 = '$' + Utils.formatSplit(res.data.data.profitTarget)
        // 第三行
        if (res.data.data.cogsPercentage)
          this.tableData[2].num1 = res.data.data.cogsPercentage + '%'
        if (res.data.data.cogs)
          this.tableData[2].num2 = '$' + Utils.formatSplit(res.data.data.cogs)
        // 第四行
        if (res.data.data.operatingExpensesPercentage)
          this.tableData[3].num1 = res.data.data.operatingExpensesPercentage + '%'
        if (res.data.data.operatingExpenses)
          this.tableData[3].num2 = '$' + Utils.formatSplit(res.data.data.operatingExpenses)

        // 第五行
        if (res.data.data.weeklyRentPercentage)
          this.tableData[4].num1 = res.data.data.weeklyRentPercentage + '%'
        if (res.data.data.weeklyRent)
          this.tableData[4].num2 = '$' + Utils.formatSplit(res.data.data.weeklyRent)


        // 第六行
        if (res.data.data.labourCostPercentage)
          this.tableData[5].num1 = res.data.data.labourCostPercentage + '%'
        if (res.data.data.labourCost)
          this.tableData[5].num2 = '$' + Utils.formatSplit(res.data.data.labourCost)
        if (res.data.data.labourHours)
          this.temp = Utils.formatDecimal(res.data.data.labourHours, 2) + 'Hrs'

        // 开启what if mode需要用到的数据
        let result = res.data.data
        this.profit1 = result.profitTargetPercentage ? result.profitTargetPercentage : null
        this.profit2 = result.profitTarget ? result.profitTarget : null
        this.cog1 = result.cogsPercentage ? result.cogsPercentage : null
        this.cog2 = result.cogs ? result.cogs : null
        this.oe1 = result.operatingExpensesPercentage ? result.operatingExpensesPercentage : null
        this.oe2 = result.operatingExpenses ? result.operatingExpenses : null
        this.labour1 = result.labourCostPercentage ? result.labourCostPercentage : null
        this.labour2 = result.labourCost ? result.labourCost : null

        this.rent1 = result.weeklyRentPercentage ? result.weeklyRentPercentage : null
        this.rent2 = result.weeklyRent ? result.weeklyRent : null


        /*let revenue = 0
        if (this.profit2)
            revenue += (this.profit2 * 1000)
        if (this.cog2)
            revenue += (this.cog2 * 1000)
        if (this.oe2)
            revenue += (this.oe2 * 1000)
        if (this.labour2)
            revenue += (this.labour2 * 1000)
        if (this.rent2)
            revenue += (this.rent2 * 1000)
        if (revenue > 0)
          this.revenue = revenue / 1000*/
        this.revenue = res.data.data.forecastRevenue


        this.profit1 = typeof(this.profit1) === 'string' ? this.profit1 : (this.profit1 ? JSON.stringify(this.profit1) : null)
        this.profit2 = typeof(this.profit2) === 'string' ? this.profit2 : (this.profit2 ? JSON.stringify(this.profit2) : null)
        this.cog1 = typeof(this.cog1) === 'string' ? this.cog1 : (this.cog1 ? JSON.stringify(this.cog1) : null)
        this.cog2 = typeof(this.cog2) === 'string' ? this.cog2 : (this.cog2 ? JSON.stringify(this.cog2) : null)
        this.oe1 = typeof(this.oe1) === 'string' ? this.oe1 : (this.oe1 ? JSON.stringify(this.oe1) : null)
        this.oe2 = typeof(this.oe2) === 'string' ? this.oe2 : (this.oe2 ? JSON.stringify(this.oe2) : null)
        this.labour1 = typeof(this.labour1) === 'string' ? this.labour1 : (this.labour1 ? JSON.stringify(this.labour1) : null)
        this.labour2 = typeof(this.labour2) === 'string' ? this.labour2 : (this.labour2 ? JSON.stringify(this.labour2) : null)

        this.rent1 = typeof(this.rent1) === 'string' ? this.rent1 : (this.rent1 ? JSON.stringify(this.rent1) : null)
        this.rent2 = typeof(this.rent2) === 'string' ? this.rent2 : (this.rent2 ? JSON.stringify(this.rent2) : null)
      } else {
        Utils.alert('', res.data.message ,'error')
      }
    },
    toggle() {
      if (this.tableData[5].tit === 'Labour($)') {
        this.tableData[5].tit = 'Labour(Hrs)'
      } else {
        this.tableData[5].tit = 'Labour($)'
      }
      let temp = this.tableData[5].num2
      this.tableData[5].num2 = this.temp
      this.temp = temp
    },

    addTableData() {
      this.tableData = [
        {
          tit: 'Forecast Revenue',
          sort: 0,
          num1: '',
          num2: '-',
          isDisplayed: true
        },
        {
          tit: 'Profit target',
          sort: 1,
          num1: '-',
          num2: '-',
          isDisplayed: true
        },
        {
          tit: 'COGs',
          sort: 2,
          num1: '-',
          num2: '-',
          isDisplayed: this.isPro
        },
        {
          tit: 'Operating Expenses',
          sort: 3,
          num1: '-',
          num2: '-',
          isDisplayed: this.isPro
        },
        {
          tit: 'Weekly Rent',
          sort: 6,
          num1: '-',
          num2: '-',
          isDisplayed: this.isPro
        },
        {
          tit: 'Labour($)',
          sort: 4,
          num1: '-',
          num2: '-',
          isDisplayed: true
        }
      ]
    },


    closeOrLogoutVenue(isSubscribe) {
      if (isSubscribe) {
        this.isTrialEnd = false
        return
      }
      if (this.venueDiscountDetailsPojo.remainingDays <= 0) {
        this.$root.$emit('logout-venue')
      } else {
        const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
        if (isContUsingTrial == '0') {
          sessionStorage.setItem('isContUsingTrial', '1')
        }
        this.isTrialEnd = false
      }
    }
  },
  computed: {
    showTableData() {
      var tableData = this.tableData.filter(n => n.isDisplayed)

      return tableData
    }
  },
  components: {
    pinDialog,
    pinModeDialog,
    cardUnauthorized: cardUnauthorized,
    freeTrialNotice: freeTrialNotice
  },
  beforeRouteLeave (to,from, next) {
    this.timeout.forEach(i => {
      clearTimeout(i)
    })
    next()
  }
}
</script>

<style lang="scss" scoped>
.edit-table{
  box-sizing: border-box;
  border-top: 1px solid #5F5F5F;
  border-left: 1px solid #5F5F5F;
  .line{
    display: flex;
    flex-direction: row;
    .cloumn{
      width: 33.33%;
      flex: 1;
      border-bottom: 1px solid #5F5F5F;
      border-right: 1px solid #5F5F5F;
      box-sizing: border-box;
      padding: 10px 35px 10px 50px;
      line-height: 40px;
      position: relative;
      &:nth-child(1){
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        padding-left: 20px;
      }
      &:nth-last-child(1){
        padding-right: 20px;
      }
      .unlock, .lock{
        position: absolute;
        left: 20px;
        top: 15px;
        cursor: pointer;
        width: 30px;
        height: 30px;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: 23px auto;
      }
      .unlock{
        background-image: url('../../assets/lock.png');
      }
      .lock{
        background-image: url('../../assets/lock2.png');
      }
      .input1, .input2{
        width: 100%;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        height: 30px;
        background: transparent;
        border: none;
        outline: none;
        text-align: right;
      }
      .format-value{
        position: absolute;
        top: 15px;
        left: 45px;
        right: 0;
        line-height: 30px;
        text-align: right;
        box-sizing: border-box;
        padding: 0 20px 0 0;
      }
      .perc{
        position: absolute;
        line-height: 60px;
        top: 0;
        right: 20px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
      }
    }
  }
  .locked{
    background: #342633;
  }
  .line:nth-last-child(1) .cloumn:nth-child(1){
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
  }
}
.mode-wrap{
  float: right;
  box-sizing: border-box;
  width: 280px;
  height: 60px;
  background: var(--background-color-3);
  border: 1px solid #636363;
  padding-left: 20px;
  .switch{
    float: left;
    width: 28px;
    height: 28px;
    margin-right: 15px;
    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;
    background-image: url('../../assets/h.png');
    margin-top: 16px;
    cursor: pointer;
  }
  .text{
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }
  .active{
    background-image: url('../../assets/h1.png');
  }
}
.linkDio-tit{
  width: 100%;
  text-align: center;
  height: 33px;
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color);
  line-height: 33px;
  margin-bottom: 50px;
}
.pin-input-wrp{
  width: 100%;
  position: relative;
  margin-bottom: 65px;
  input{
    outline: none;
    width: 100%;
    background: var(--background-color-2);
    height: 50px;
    box-sizing: border-box;
    border: 1px solid #5F5F5F;
    font-size: 16px;
    padding-left: 15px;
    color: var(--text-color);
  }
}
.btns{
  margin: 65px auto 0 auto;
  width: 610px;
  button{
    width:280px;
    height:60px;
    outline: none;
    background: none;
    cursor: pointer;
    font-weight: 600;
  }
  .dark{
    border: 2px solid var(--text-color);
    color: var(--text-color);
    font-size: 26px;
    float: left;
  }
  .light{
    border: 2px solid #EA3796;
    color: #EA3796;
    font-size: 26px;
    float: right;
  }
}
.wrp{
  width: 100%;
  color: var(--text-color);
  min-width: 724px;
  .h1{
    font-size: 24px;
    margin-bottom: 12px;
    font-weight: 600;
    line-height:60px

  }
  h2{
    line-height: 70px;
    width: 100%;
    box-sizing: border-box;
    padding-left: 30px;
    font-size:20px;
    font-weight:600;
    color: var(--text-color);
  }
  .table-wrp{
    width: 100%;
    background: var(--background-color-2);
    .normal{
      font-size: 18px;
    }
    .bold-row{
      font-weight: 600;
      font-size: 20px;
      .switch{
        width: 28px;
        height: 28px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        background-image: url('../../assets/t.png');
        cursor: pointer;
        float: right;
      }
      .visible{
        width: 28px;
        height: 28px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        background-image: url('../../assets/eye2.png');
        cursor: pointer;
        float: right;
      }
      .invisible{
        width: 28px;
        height: 28px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: contain;
        background-image: url('../../assets/eye.png') !important;
        cursor: pointer;
        float: right;
      }

    }
    .rgt{
      text-align:right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/venue/index.vue